<section class="prod-sb">
  @if (fourthnode | async; as item) {
    <div class="container prod-sb__body">
      @if (item?.mediaPicture) {
        <div class="prod-sb__left">
          <img class="prod-sb__img" alt="product logo" [src]="getImage(item.mediaPicture)">
        </div>
      }
      <div class="prod-sb__right prod-sb__right--light">
        <h2 [innerHTML]="item.h2content"></h2>
        @if (item?.content) {
          <a class="prod-sb__link ord_enable" routerLink="/start-order" >{{ item.content }}</a>
        }
      </div>
    </div>
  }
</section>